import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex justify-end" }
const _hoisted_9 = { class: "flex pt-3 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Inserimento dati contabilità generali ", -1)),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
    }, [
      _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
      _createElementVNode("i", {
        class: "icon-x cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
      })
    ], 2), [
      [_vShow, _ctx.response_message.length]
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4\"><p class=\"font-bold pb-2 text-sm\">Tipologia</p><p class=\"font-bold pb-2 text-sm\">Alla data</p><p class=\"font-bold pb-2 text-sm\">Valore</p><p class=\"w-8\"> </p></div>", 1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contabilita, (contabilita, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            "label-visible": false,
            errors: _ctx.getContabilitaErrors(i,'contabilita', 'tipologia')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                options: _ctx.tipologiaContabilita.options,
                onSearchChange: _ctx.tipologiaContabilita.search,
                "track-by": "id",
                label: "descrizione",
                modelValue: contabilita.tipologia_contabilita,
                "onUpdate:modelValue": ($event: any) => ((contabilita.tipologia_contabilita) = $event),
                placeholder: "Tipologia",
                class: "next-vue-multiselect-single",
                "internal-search": false,
                "close-on-select": true,
                "clear-on-select": true
              }, null, 8, ["options", "onSearchChange", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            "label-visible": false,
            errors: _ctx.getContabilitaErrors(i,'contabilita', 'data')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((contabilita.data) = $event),
                type: "date",
                class: "p-7px bg-next-gray-md-dark hover:bg-white"
              }, null, 8, _hoisted_4), [
                [_vModelText, contabilita.data]
              ])
            ]),
            _: 2
          }, 1032, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            "label-visible": false,
            errors: _ctx.getContabilitaErrors(i,'contabilita', 'valore')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((contabilita.valore) = $event),
                type: "number",
                step: "0.01",
                class: "p-7px bg-next-gray-md-dark hover:bg-white"
              }, null, 8, _hoisted_6), [
                [_vModelText, contabilita.valore]
              ])
            ]),
            _: 2
          }, 1032, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: ($event: any) => (_ctx.remove(i)),
            class: "col flex justify-center items-center h-8 w-8"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "icon-x" }, null, -1)
            ])),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.add,
        class: "col flex justify-center items-center h-8 w-8"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_NextButton, {
        class: "px-3 py-2",
        onClick: _ctx.saveContabilita
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Salva")
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}